import React from 'react'
import mapboxgl from 'mapbox-gl'
import 'moment-timezone';
import { Analytics } from './analytics.js';
import Toolbar from './components/toolbar'
import { withCookies} from 'react-cookie';
import TokenManager from "./utils/tokenManager";
import TripApiService from "./services/tripApiService";
import { withRouter } from "react-router-dom";


mapboxgl.accessToken = 'pk.eyJ1IjoiemFjaHdpbmtsZXIxIiwiYSI6ImNsZ2gweG51bjAybGczZm9jNXJ4ejd3OGMifQ.ZFrklwURBHxuBWINw_bsPg';

let map;


class App extends React.Component {

    constructor(props) {
        super(props);

        console.log(props)
        const { cookies } = props
        const tokenManager = new TokenManager(cookies)
        tokenManager.setTokenIfNeeded() //eat url token & set to cookie
        this.tripApiService = new TripApiService(tokenManager);
        var tripId = getParameterByName('trip_id');
        var hasToken = getParameterByName('token') !== null;
        if(hasToken) {
            this.cleanUrl()
        }


        this.state = {
            lng: -118.491188,
            lat: 34.019455,
            zoom: 11,
            battery_status: {
                battery_level: null,
                last_updated_at: null
            },
            trip: {
                id: tripId,
                state: null,
                last_location_date:  null
            }
        };

    }

    cleanUrl() {
        var tripId = getParameterByName('trip_id');
        var cleanWindowLoc = {
            pathname: "/",
            search: `trip_id=${tripId}`
        }
        this.props.history.replace(cleanWindowLoc)
    }


    async componentDidMount() {
        const { lng, lat, zoom } = this.state;

        var style = window.location.search.indexOf('satellite') >= 0 ? 'mapbox://styles/mapbox/satellite-v9' : 'mapbox://styles/mapbox/streets-v9';

        map = new mapboxgl.Map({
            container: this.mapContainer,
            style: style,
            center: [lng, lat],
            zoom
        });

        // Add geolocate control to the map.
        map.addControl(new mapboxgl.GeolocateControl({
            positionOptions: {
                enableHighAccuracy: true
            },
            trackUserLocation: true
        }));


        var size = 200;

        var pulsingDot = {
            width: size,
            height: size,
            data: new Uint8Array(size * size * 4),

            onAdd: function() {
                var canvas = document.createElement('canvas');
                canvas.width = this.width;
                canvas.height = this.height;
                this.context = canvas.getContext('2d');
            },

            render: function() {
                var duration = 1000;
                var t = (performance.now() % duration) / duration;

                var radius = size / 2 * 0.3;
                var outerRadius = size / 2 * 0.7 * t + radius;
                var context = this.context;

// draw outer circle
                context.clearRect(0, 0, this.width, this.height);
                context.beginPath();
                context.arc(this.width / 2, this.height / 2, outerRadius, 0, Math.PI * 2);
                context.fillStyle = 'rgba(22, 110, 248,' + (1 - t) + ')';
                context.fill();

// draw inner circle
                context.beginPath();
                context.arc(this.width / 2, this.height / 2, radius, 0, Math.PI * 2);
                context.fillStyle = 'rgba(22, 110, 248, 1)';
                context.strokeStyle = 'white';
                context.lineWidth = 2 + 4 * (1 - t);
                context.fill();
                context.stroke();

// update this image's data with data from the canvas
                this.data = context.getImageData(0, 0, this.width, this.height).data;

// keep the map repainting
                map.triggerRepaint();

// return `true` to let the map know that the image was updated
                return true;
            }
        };


        map.on('move', () => {
            const { lng, lat } = map.getCenter();

            this.setState({
                lng: lng.toFixed(4),
                lat: lat.toFixed(4),
                zoom: map.getZoom().toFixed(2)
            });
        });

        map.on('load', () => {
            console.log("loaded");


            var data = {
                "type": "FeatureCollection",
                "features": [
                    {
                        "type": "Feature",
                        "properties": {},
                        "geometry": {
                            "type": "LineString",
                            "coordinates": []
                        }
                    }
                ]
            };

            map.addSource('trace', {type: 'geojson', data: data});
            map.addLayer({
                "id": "trace",
                "type": "line",
                "source": "trace",
                "paint": {
                    "line-color": "#166ef8",
                    "line-opacity": 0.75,
                    "line-width": 5
                }
            });

            map.addSource('point', {
                "type": "geojson",
                "data": {
                    "type": "Point",
                    "coordinates": []
                }
            });
            map.addImage('pulsing-dot', pulsingDot, { pixelRatio: 2 });
            map.addLayer({
                "id": "points",
                "type": "symbol",
                "source": "point",
                "layout": {
                    "icon-image": "pulsing-dot"
                }
            });

            this.reloadTripData(data);


            // map.jumpTo({ 'center': [], 'zoom': 12 });
            map.setPitch(30);

            var that = this;
            window.setInterval(function() {
                that.reloadTripData(data);
            }, 5000);



        });
    }

    async reloadTripData (data) {
        var that = this;
        var tripId = this.state.trip.id

        Analytics.track('Reload Trip Data',{tripId: tripId});

        try {
            const resp = await this.tripApiService.fetchTrip(tripId)

                var batteryStatus = getMostRecentBatteryLevel(resp);

                var trip = getTripObjectFromJson(resp);
                if(trip && trip.id) {
                    that.setState({
                        trip: trip,
                        battery_status: batteryStatus
                    });
                }


                var currentCount = data.features[0].geometry.coordinates.length;
                var newLocs = resp.locations;
                newLocs.sort(function(a,b){
                    return new Date(a.created_at) - new Date(b.created_at);
                });
                newLocs = newLocs.slice(currentCount);
                // var newLocs = resp.locations;
                // console.log(newLocs[0]);
                // console.log(newLocs[newLocs.length - 1]);

                if(newLocs != null && newLocs.length > 0) {
                    newLocs = newLocs.map(function(obj){
                        return [ obj.lng, obj.lat]
                    });

                    for(var i = 0; i < newLocs.length; i++) {
                        data.features[0].geometry.coordinates.push(newLocs[i]);
                    }

                    map.getSource('trace').setData(data);
                    map.panTo(newLocs[newLocs.length - 1]);
                    map.getSource('point').setData({
                        "type": "Point",
                        "coordinates": newLocs[newLocs.length - 1]
                    });
                }
        } catch (e) {
            console.log(e)
        }
    };


    render() {



        return (
                <div>
                    <div ref={el => this.mapContainer = el} className="absolute top right left bottom" />
                    <Toolbar trip={this.state.trip} battery_status={this.state.battery_status} tripApiService={this.tripApiService}/>
                </div>
        );
    }
}


function getMostRecentBatteryLevel(json) {


    if (json && json.locations && json.locations.length > 0) {
        var locations = json.locations;
        locations.sort(function(a,b){
            return new Date(a.created_at) - new Date(b.created_at);
        });
        var mostRecentLoc = locations.slice(-1)[0]

        if (mostRecentLoc.battery_level) {
            var batteryLevel = mostRecentLoc.battery_level;
            batteryLevel = (batteryLevel * 100).toFixed(0);
            var batteryStatus = {
                battery_level: batteryLevel,
                last_updated_at: mostRecentLoc.created_at
            };
            return batteryStatus;
        }
    }
    return null;

}

function getParameterByName(name) {
    var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

function getTripObjectFromJson(json) {

    if(json && json._id && json.locations && json.statuses) {
        var trip_id = json._id;

        var last_location = {
            created_at: null
        };

        if(json.locations.length > 0) {
            var locations = json.locations;
            locations.sort(function(a,b){
                return new Date(a.created_at) - new Date(b.created_at);
            });

            last_location = locations.slice(-1)[0]

        }

        var state = json.statuses[json.statuses.length-1];

        return {
            id: trip_id,
            last_location_date: last_location.created_at,
            state: state.status,
            state_last_changed: state.created_at
        };
    } else {
        return {
            id: null,
            last_location_date: null,
            state: null
        };
    }

}

export default withRouter(withCookies(App))


// WEBPACK FOOTER //
// ./src/App.js